import docsStore from './docs';

module.exports = {
  docsStore,
};




// WEBPACK FOOTER //
// ./stores/index.js